import React, { Fragment, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const REDIRECT_URL = 'https://gappeo.ai/';

function CouponRedeem() {
    const [secondsLeft, setSecondsLeft] = useState(5);

    useEffect(() => {
        if (secondsLeft === 0) {
            window.location.href = REDIRECT_URL;
            return;
        }
        const timer = setTimeout(() => setSecondsLeft((s) => s - 1), 1000);
        return () => clearTimeout(timer);
    }, [secondsLeft]);

    return (
        <Fragment>
            <div
                style={{
                    height: '100vh',
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    padding: '24px',
                    background: 'radial-gradient(ellipse at center, #3a0f22 0%, #180a13 45%, #0a0609 100%)',
                }}
            >
                <img src={'/images/logo.png'} alt="Gappeo" height="60px" />
                <h1 style={{ color: '#fff', fontWeight: 700, fontSize: '2.5rem', margin: '24px 0 32px' }}>
                    gappeo.ai
                </h1>
                <a
                    href="https://gappeo.ai/"
                    rel="noopener noreferrer"
                    style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        background: 'linear-gradient(90deg, #ec4899, #db2777)',
                        color: '#fff',
                        fontWeight: 700,
                        fontSize: '1.1rem',
                        padding: '14px 32px',
                        borderRadius: '30px',
                        textDecoration: 'none',
                        boxShadow: '0 8px 24px rgba(219, 39, 119, 0.35)',
                    }}
                >
                    Go to Gappeo.ai
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 17L17 7M17 7H9M17 7V15" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </a>
                <p style={{ color: '#999', fontSize: '0.9rem', marginTop: '20px' }}>
                    Redirecting in {secondsLeft}s...
                </p>
                <h5 style={{ color: '#ccc', fontSize: '0.95rem', marginTop: '40px' }}>
                    If you are an existing user of gappeo.com, sign in{' '}
                    <Link to="/login" style={{ color: '#ec4899', fontWeight: 600 }}>
                        here
                    </Link>
                </h5>
            </div>
        </Fragment>
    );
}

export default CouponRedeem;
